import { render } from "./CardList.vue?vue&type=template&id=3c4e02bc&ts=true"
import script from "./CardList.vue?vue&type=script&lang=ts"
export * from "./CardList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__